/**
 * Combine all reducers in this file and export the combined reducers.
 */
// Library Methods

// Reducers
import { bulkPaymentLinkReducer } from 'containers/BulkPaymentLink/redux/BulkPaymentLink.reducers';
import { bulkAccountVerificationReducer } from 'containers/BulkAccountVerification/redux/BulkAccountVerification.reducers';
import { merchantReducer } from '../containers/MerchantOnboard/redux/merchantOnBoard.reducer';
import { editMerchantReducer } from '../containers/MerchantOnboard/redux/editMerchant/editMerchant.reducer';
import { pgConfigReducer } from '../containers/MerchantOnboard/redux/pgConfig/pgConfig.reducer';
import { userManagementReducer } from '../containers/UserManagement/redux/userManagement.reducer';
import { roleManagementReducer } from '../containers/RoleManagement/redux/roleManagement.reducer';
import { transactionsReducer } from '../containers/Transactions/redux/transactions.reducer';
import { adjustmentsReducer } from '../containers/MerchantAdjustments/redux/adjustments.reducer';
import { refundReducer } from '../containers/Refund/redux/refund.reducer';
import { userVerificationReducer } from '../containers/UserVerification/redux/userVerification.reducer';
import { roleVerificationReducer } from '../containers/RoleVerification/redux/roleVerification.reducer';
import { commProfileReducer } from '../containers/CommProfile/redux/commProfile.reducer';
import { manageBinReducer } from '../containers/ManageBin/redux/manageBin.reducer';
import { profileReducer } from '../containers/Profile/redux/profile.reducer';
import { settlementReducer } from '../containers/Settlement/redux/settlement.reducer';
import { paymentLinkReducer } from '../containers/PaymentLink/redux/paymentLink.reducer';
import { auditTrailReducer } from '../containers/AuditTrail/redux/auditTrail.reducer';
import { dashBoardReducer } from '../containers/Dashboard/redux/dashboard.reducer';
import { checkoutReducer } from '../containers/checkoutCustom/redux/checkout.reducer';
import { bulRefundReducer } from '../containers/BulkRefund/redux/bulkRefund.reducer';
import { merchantOnboardStatusReducer } from '../containers/MerchantOnboardStatus/redux/MerchantOnboardStatus.reducer';
import { makerReducer } from '../containers/Maker/redux/maker.reducer';
import { checkerReducer } from '../containers/Checker/redux/checker.reducer';
import { mandatesReducer } from '../containers/Mandate/redux/mandates.reducers';
import { chargebackReducer } from '../containers/Chargeback/redux/chargeback.reducer';
import { merchantLegalEntityReducer } from '../containers/MerchantLegalEntity/redux/merchantLegalEntity.reducer';
import { paymentGatewayCredentialsReducer } from '../containers/PaymentGatewayCredentials/redux/paymentGatewayCredentials.reducer';
import { invoiceReducer } from '../containers/Invoice/redux/invoice.reducer';
import { authReducer } from './common/auth/auth.reducer';
import { loaderReducer } from './common/loader/loader.reducer';
import { staticDataReducer } from './common/staticData/staticData.reducer';
import { TIDReducer } from '../containers/TerminalOnboard/redux/TIDOnBoard.reducer';
import { paymentPageReducer } from '../containers/PaymentPage/redux/paymentPage.reducer';
import { reducer as formReducer } from 'redux-form';
import { combineReducers } from 'redux';

// Merges all the reducers to a root reducer
function createRootReducer(injectedReducers = {}) {
    return combineReducers({
        auth: authReducer,
        form: formReducer,
        loader: loaderReducer,
        staticData: staticDataReducer,
        merchantData: merchantReducer,
        userManagementData: userManagementReducer,
        roleManagementData: roleManagementReducer,
        userVerificationData: userVerificationReducer,
        roleVerificationData: roleVerificationReducer,
        pgData: pgConfigReducer,
        editData: editMerchantReducer,
        transactionData: transactionsReducer,
        adjustmentsData: adjustmentsReducer,
        refundData: refundReducer,
        manageBin: manageBinReducer,
        commData: commProfileReducer,
        profileData: profileReducer,
        paymentLinkData: paymentLinkReducer,
        auditTrailData: auditTrailReducer,
        settlementData: settlementReducer,
        dashboard: dashBoardReducer,
        checkoutData: checkoutReducer,
        bulkRefundData: bulRefundReducer,
        merchantOnBoardStatusData: merchantOnboardStatusReducer,
        invoiceData: invoiceReducer,
        bulkPaymentLinkData: bulkPaymentLinkReducer,
        bulkAccountVerificationData: bulkAccountVerificationReducer,
        makerData: makerReducer,
        checkerData: checkerReducer,
        mandateData: mandatesReducer,
        chargebackData: chargebackReducer,
        merchantLegalEntityData: merchantLegalEntityReducer,
        paymentGatewayCredentialsData: paymentGatewayCredentialsReducer,
        terminalsData: TIDReducer,
        paymentPageData : paymentPageReducer,
        ...injectedReducers,
    });
}

export default createRootReducer;
